import { Currency } from '../types';

export const currencies: Currency[] = [
  { code: 'USD', symbol: '$', flag: '🇺🇸', rate: 1 },
  { code: 'EUR', symbol: '€', flag: '🇪🇺', rate: 0.92 },
  { code: 'GBP', symbol: '£', flag: '🇬🇧', rate: 0.79 },
  { code: 'PLN', symbol: 'zł', flag: '🇵🇱', rate: 3.97 },
];

export const formatPrice = (amount: number, currency: Currency): string => {
  const value = (amount * currency.rate).toFixed(2);
  return `${currency.symbol}${value}`;
};

export const getUserCurrency = (): Currency => {
  try {
    const userLocale = navigator.language;
    const userCurrency = new Intl.NumberFormat(userLocale, { 
      style: 'currency', 
      currency: 'USD' 
    }).resolvedOptions().currency;
    
    const matchedCurrency = currencies.find(c => c.code === userCurrency);
    return matchedCurrency || currencies[0]; // Default to USD if no match
  } catch {
    return currencies[0]; // Default to USD if error
  }
};